module.exports = __webpack_public_path__ + "static/media/icon1.56d9c13c.jpg";